
















































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
import { PostModelTrial } from "@/request/model";
import Copy from "@/components/copy.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/model-left-nav.vue";
import TypeTransfer from "./type-transfer.vue";
@Component({
  components: {
    Copy,
    MainHeader,
    LeftNav,
    TypeTransfer
  }
})
export default class ModelTrial extends Vue {
  private message: any = {
    info: {},
    version_id: "",
    model_id: ""
  };
  private models: any[] = [];
  private versions: any[] = [];
  private cModel: any = {
    model_id: ""
  };
  private cVersion: any = {
    version_id: ""
  };
  // 智能预测结果列表
  private result: any = {};
  private ifGetResult: boolean = false;
  /**
   * @description 获取模型列表
   */
  private fetchModels() {
    return new Promise((resolve, reject) => {
      axios.get("api/model/train/models").then(({ data }) => {
        resHandle(this, data).then(() => {
          this.models = data.data;
          this.models.forEach((model: any) => {
            model.type = model["类型"];
          });
          resolve();
        });
      });
    });
  }
  /**
   * @description 获取版本
   */
  private fetchVersions() {
    if (!this.message.model_id) {
      return;
    }
    this.models.forEach((m: any) => {
      if (m.model_id === this.message.model_id) {
        this.cModel = m;
      }
    });
    const params: any = {
      params: {
        model_id: this.message.model_id
      }
    };
    axios.get("api/model/predict/versions", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.versions = data.data;
        this.message.version_id = "";
        this.cVersion = {};
      });
    });
  }
  /**
   * @description 版本选择改变
   */
  private versionChange(versionId) {
    this.versions.map((version: any) => {
      if (version.version_id === versionId) {
        this.cVersion = version;
      }
    });
  }
  /**
   * @description 跳转模型报告
   */
  private goToReport(model) {
    this.$router.push("/main/model/model-report/" + model.model_id);
  }
  /**
   * @description 开始分析
   */
  private start() {
    if (!this.cModel.model_id) {
      this.$message.warning("请选择一个模型");
      return;
    }
    if (!this.cVersion.version_id) {
      this.$message.warning("请选择模型的一个版本");
      return;
    }
    const params: any = {
      model_id: this.cModel.model_id,
      version_id: this.cVersion.version_id,
      info: this.message.info
    };
    const typeArr1: any[] = [
      "舌图疾病筛查模型",
      "舌图辅助辨证模型",
      "齿痕分类模型",
      "舌苔厚薄分类模型"
    ];
    if (typeArr1.includes(this.cModel["类型"])) {
      if (!this.message.info.url) {
        this.$message.warning("请先上传图片");
        return;
      }
    }
    const typeArr2: any[] = [
      "疾病辅助辨证模型",
      "疾病处方推荐模型",
      "体质辨识模型"
    ];

    if (typeArr2.includes(this.cModel["类型"])) {
      if (this.message.info["刻下症"].length === 0) {
        this.$message.warning("刻下症必须填写");
        return;
      }
    }
    const loading = this.$loading({ text: "分析中..." });
    PostModelTrial(this, params)
      .then((data: any) => {
        this.result = data;
        this.ifGetResult = true;
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.fetchModels().then(() => {
      if (this.$route.params.model_id) {
        this.message.model_id = this.$route.params.model_id;
        this.fetchVersions();
      }
    });
  }
}
